// Class: starling.filters.BlurEffect

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;
var $import = require("./../../import_stub").default;
var $extend = require("./../../extend_stub").default;
function starling_rendering_FilterEffect() {return require("./../../starling/rendering/FilterEffect");}
function starling_rendering_Program() {return require("./../../starling/rendering/Program");}
function openfl__$Vector_Vector_$Impl_$() {return require("./../../openfl/_Vector/Vector_Impl_");}

// Constructor

var BlurEffect = function() {
	(starling_rendering_FilterEffect().default).call(this);
	this._strength = 0.0;
	this._direction = "horizontal";
	this._quality = 1.0;
}

// Meta

BlurEffect.__name__ = "starling.filters.BlurEffect";
BlurEffect.__isInterface__ = false;
BlurEffect.__super__ = (starling_rendering_FilterEffect().default);
BlurEffect.prototype = $extend((starling_rendering_FilterEffect().default).prototype, {
	createProgram: function() {
		if(this._strength == 0) {
			return (starling_rendering_FilterEffect().default).prototype.createProgram.call(this);
		}
		var vertexShader = ["m44 op, va0, vc0      ","mov v0, va1           ","add v1,  va1, vc4.xyww","sub v2,  va1, vc4.xyww","add v3,  va1, vc4.zwxx","sub v4,  va1, vc4.zwxx"].join("\n");
		var fragmentShader = [(starling_rendering_FilterEffect().default).tex("ft0","v0",0,this.get_texture()),"mul ft5, ft0, fc0.xxxx       ",(starling_rendering_FilterEffect().default).tex("ft1","v1",0,this.get_texture()),"mul ft1, ft1, fc0.yyyy       ","add ft5, ft5, ft1            ",(starling_rendering_FilterEffect().default).tex("ft2","v2",0,this.get_texture()),"mul ft2, ft2, fc0.yyyy       ","add ft5, ft5, ft2            ",(starling_rendering_FilterEffect().default).tex("ft3","v3",0,this.get_texture()),"mul ft3, ft3, fc0.zzzz       ","add ft5, ft5, ft3            ",(starling_rendering_FilterEffect().default).tex("ft4","v4",0,this.get_texture()),"mul ft4, ft4, fc0.zzzz       ","add  oc, ft5, ft4            "].join("\n");
		return (starling_rendering_Program().default).fromSource(vertexShader,fragmentShader);
	},
	beforeDraw: function(context) {
		(starling_rendering_FilterEffect().default).prototype.beforeDraw.call(this,context);
		if(this._strength != 0) {
			this.updateParameters();
			context.setProgramConstantsFromVector("vertex",4,BlurEffect.sOffsets);
			context.setProgramConstantsFromVector("fragment",0,BlurEffect.sWeights);
		}
	},
	updateParameters: function() {
		var offset1;
		var offset2;
		var pixelSize = 1.0 / (this._direction == "horizontal" ? this.get_texture().get_root().get_nativeWidth() : this.get_texture().get_root().get_nativeHeight());
		if(this._strength <= 1) {
			var sigma = this._strength * 2;
			var twoSigmaSq = 2 * sigma * sigma;
			var multiplier = 1.0 / Math.sqrt(twoSigmaSq * Math.PI);
			(openfl__$Vector_Vector_$Impl_$().default).set(BlurEffect.sTmpWeights,0,multiplier * Math.exp(0 / twoSigmaSq));
			(openfl__$Vector_Vector_$Impl_$().default).set(BlurEffect.sTmpWeights,1,multiplier * Math.exp(-1 / twoSigmaSq));
			(openfl__$Vector_Vector_$Impl_$().default).set(BlurEffect.sTmpWeights,2,multiplier * Math.exp(-4 / twoSigmaSq));
			(openfl__$Vector_Vector_$Impl_$().default).set(BlurEffect.sTmpWeights,3,multiplier * Math.exp(-9 / twoSigmaSq));
			(openfl__$Vector_Vector_$Impl_$().default).set(BlurEffect.sTmpWeights,4,multiplier * Math.exp(-16 / twoSigmaSq));
			(openfl__$Vector_Vector_$Impl_$().default).set(BlurEffect.sWeights,0,BlurEffect.sTmpWeights[0]);
			(openfl__$Vector_Vector_$Impl_$().default).set(BlurEffect.sWeights,1,BlurEffect.sTmpWeights[1] + BlurEffect.sTmpWeights[2]);
			(openfl__$Vector_Vector_$Impl_$().default).set(BlurEffect.sWeights,2,BlurEffect.sTmpWeights[3] + BlurEffect.sTmpWeights[4]);
			var weightSum = BlurEffect.sWeights[0] + 2 * BlurEffect.sWeights[1] + 2 * BlurEffect.sWeights[2];
			var invWeightSum = 1.0 / weightSum;
			var _g = BlurEffect.sWeights;
			(openfl__$Vector_Vector_$Impl_$().default).set(_g,0,_g[0] * invWeightSum);
			var _g1 = BlurEffect.sWeights;
			(openfl__$Vector_Vector_$Impl_$().default).set(_g1,1,_g1[1] * invWeightSum);
			var _g2 = BlurEffect.sWeights;
			(openfl__$Vector_Vector_$Impl_$().default).set(_g2,2,_g2[2] * invWeightSum);
			offset1 = (BlurEffect.sTmpWeights[1] + 2 * BlurEffect.sTmpWeights[2]) / BlurEffect.sWeights[1];
			offset2 = (3 * BlurEffect.sTmpWeights[3] + 4 * BlurEffect.sTmpWeights[4]) / BlurEffect.sWeights[2];
		} else {
			(openfl__$Vector_Vector_$Impl_$().default).set(BlurEffect.sWeights,0,0.29412);
			(openfl__$Vector_Vector_$Impl_$().default).set(BlurEffect.sWeights,1,0.23529);
			(openfl__$Vector_Vector_$Impl_$().default).set(BlurEffect.sWeights,2,0.11765);
			offset1 = this._strength * 1.3;
			offset2 = this._strength * 2.3;
		}
		if(this._direction == "horizontal") {
			(openfl__$Vector_Vector_$Impl_$().default).set(BlurEffect.sOffsets,0,offset1 * pixelSize / this._quality);
			(openfl__$Vector_Vector_$Impl_$().default).set(BlurEffect.sOffsets,1,0);
			(openfl__$Vector_Vector_$Impl_$().default).set(BlurEffect.sOffsets,2,offset2 * pixelSize / this._quality);
			(openfl__$Vector_Vector_$Impl_$().default).set(BlurEffect.sOffsets,3,0);
		} else {
			(openfl__$Vector_Vector_$Impl_$().default).set(BlurEffect.sOffsets,0,0);
			(openfl__$Vector_Vector_$Impl_$().default).set(BlurEffect.sOffsets,1,offset1 * pixelSize / this._quality);
			(openfl__$Vector_Vector_$Impl_$().default).set(BlurEffect.sOffsets,2,0);
			(openfl__$Vector_Vector_$Impl_$().default).set(BlurEffect.sOffsets,3,offset2 * pixelSize / this._quality);
		}
	},
	get_programVariantName: function() {
		return (starling_rendering_FilterEffect().default).prototype.get_programVariantName.call(this) | (this._strength != 0 ? 16 : 0);
	},
	get_direction: function() {
		return this._direction;
	},
	set_direction: function(value) {
		return this._direction = value;
	},
	get_strength: function() {
		return this._strength;
	},
	set_strength: function(value) {
		return this._strength = value;
	},
	get_quality: function() {
		return this._quality;
	},
	set_quality: function(value) {
		return this._quality = value;
	}
});
BlurEffect.prototype.__class__ = BlurEffect.prototype.constructor = $hxClasses["starling.filters.BlurEffect"] = BlurEffect;

// Init

Object.defineProperties(BlurEffect.prototype,{ direction : { get : function () { return this.get_direction (); }, set : function (v) { return this.set_direction (v); }}, strength : { get : function () { return this.get_strength (); }, set : function (v) { return this.set_strength (v); }}, quality : { get : function () { return this.get_quality (); }, set : function (v) { return this.set_quality (v); }}});

// Statics


BlurEffect.HORIZONTAL = "horizontal"
BlurEffect.VERTICAL = "vertical"
BlurEffect.sTmpWeights = (openfl__$Vector_Vector_$Impl_$().default)._new(null,null,[0,0,0,0,0.])
BlurEffect.sWeights = (openfl__$Vector_Vector_$Impl_$().default)._new(null,null,[0,0,0,0.])
BlurEffect.sOffsets = (openfl__$Vector_Vector_$Impl_$().default)._new(null,null,[0,0,0,0.])

// Export

exports.default = BlurEffect;